import { H1, P } from '@ahmdigital/ui';
import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';

import { DisclaimerWrapper, StyledButton, StyledWrapper } from './styles';
import { DRAWER_IDS } from '../../../../../ahm-constants/ui';
import { ProductType } from '../../../../../types/product';
import DrawerActions from '../../../../../actions/drawer';
import headerData from './data';
import PriceDisclaimer from '../../../../price-disclaimer';

type UpliftedHeaderProps = {
  needsType?: string;
  products?: ProductType[];
};

const UpliftedHeader = ({ needsType, products }: UpliftedHeaderProps) => {
  const dispatch = useDispatch();
  const openChangeDetailsDrawer = useCallback(() => {
    DrawerActions.openDrawer(DRAWER_IDS.CHANGE_DETAILS)(dispatch);
  }, [dispatch]);

  const needsData = needsType && headerData?.[needsType];
  if (!needsData) {
    return null;
  }

  return (
    <StyledWrapper>
      <H1 looksLike="h3">{needsData.title}</H1>
      <P>{needsData.subtitle}</P>
      <DisclaimerWrapper>
        <PriceDisclaimer elementType="button" forProducts={products} highlightIncome showRefineLink={false} />
        <StyledButton variant={['smallPadding', 'border']} onClick={openChangeDetailsDrawer}>
          Edit details
        </StyledButton>
      </DisclaimerWrapper>
    </StyledWrapper>
  );
};

export default UpliftedHeader;
